import { InjectionToken } from '@angular/core';

export interface GuidedTourStep {
  /** The name of the `nrTourAnchor` the step frames. */
  anchor: string;
  title: string;
  text: string;
  /** Skipped when its anchor is not on screen, instead of holding the tour back. */
  optional?: boolean;
}

export interface GuidedTourAnchorRef {
  readonly name: () => string;
  readonly element: HTMLElement;
}

/** Lets anchors anywhere below a tour, inside other components too, register with it. */
export interface GuidedTourRegistry {
  register: (anchor: GuidedTourAnchorRef) => void;
  unregister: (anchor: GuidedTourAnchorRef) => void;
}

export const GUIDED_TOUR_REGISTRY = new InjectionToken<GuidedTourRegistry>('GUIDED_TOUR_REGISTRY');
